module.exports = __webpack_public_path__ + "img/about-icon1.2bb5d450.png";